import moment from 'moment';
import React from 'react'
import { Link } from 'react-router-dom';

const CART_SEARCH_PATH_BY_GAME = {
  loto: '/loto/cart',
  classic: '/classic/classic/search',
};

const DEFAULT_CART_SEARCH_PATH = '/vietlott/search/ticket';

export const TableRow = (props) => {
  const { value, user, gameId, cartId, createdAt } = props;

  const cartSearchPath = CART_SEARCH_PATH_BY_GAME[gameId] || DEFAULT_CART_SEARCH_PATH;

  return (
    <tr>
      <td>
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone && user.phone.replace('+84', '0')) || ""}</strong></span>
      </td>
      <td className="text-center">
        {cartId ? (
          <Link to={`${cartSearchPath}?cartId=${cartId}`}>{cartId}</Link>
        ) : ''}
      </td>
      <td className="text-center">{gameId || ''}</td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>
      <td className="text-center">{moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}</td>
    </tr>
  );
};
